import { scrollTop } from "@Shared/@Utils/utils";
import { onMounted } from "@vue/composition-api";
export const useScrollTopOnLoad = (target = "html") => {
  onMounted(() => {
    scrollTop(target);
  });
  return {
    scrollTop
  };
};